import store from "@/store";
import { debug } from "./LoggerService";

export const FEATURES = {
  RECURRING_PAYMENT_REQUEST: "RECURRING_PAYMENT_REQUEST",
  PROMOTIONAL_CODES: "PROMOTIONAL_CODES"
};

export const USER_MANAGEMENT = "User Management",
  TRANSACTION_MANAGEMENT = "Transaction Management",
  ACTIVITY_MANAGEMENT = "Activity Management",
  MERCHANT_SETTINGS = "Merchant Settings",
  PAYMENT_REQUESTS = "Payment Requests",
  PROMOCODE_MANAGEMENT = "Promocode Management",
  OTHER = "Other";

export const PERMISSION_CATEGORIES = [
  USER_MANAGEMENT,
  TRANSACTION_MANAGEMENT,
  ACTIVITY_MANAGEMENT,
  MERCHANT_SETTINGS,
  PAYMENT_REQUESTS,
  PROMOCODE_MANAGEMENT,
  OTHER
];

export const ADMIN = "Admin",
  MERCHANT_ADMIN = "MerchantAdmin",
  CAN_VIEW_USERS = "CanViewUsers",
  ADD_USER = "AddUser",
  EDIT_USER_PERMISSIONS = "EditUserPermissions",
  DELETE_USER = "DeleteUser",
  VIEW_TRANSACTIONS = "ViewTransactions",
  SEARCH_TRANSACTIONS = "SearchTransactions",
  EXPORT_TRANSACTIONS = "ExportTransactions",
  COLLECT_FUNDS = "CollectFunds",
  PARTIAL_COLLECT_FUNDS = "PartialCollectFunds",
  REFUND_TRANSACTIONS = "RefundTransactions",
  VIEW_ACTIVITY_LOG = "ViewActivityLog",
  EXPORT_ACTIVITY_LOG = "ExportActivityLog",
  EDIT_MERCHANT_SETTINGS = "EditMerchantSettings",
  VIEW_MERCHANT_SETTINGS = "ViewMerchantSettings",
  SET_CUSTOM_FIELDS = "SetCustomFields",
  SET_LOGO = "SetLogo",
  SET_BANNER = "SetBanner",
  VIEW_MERCHANTS = "ViewMerchants",
  ADD_MERCHANT = "AddMerchant",
  DELETE_MERCHANT = "DeleteMerchant",
  MAKE_A_PAYMENT = "MakeAPayment",
  SEND_RECURRING_PAYMENT_REQUEST = "SendRecurringPaymentRequest",
  CANCEL_RECURRING_PAYMENT = "CancelRecurringPayment",
  STANDARD_PAYMENT_REQUEST = "StandardPaymentRequest",
  VIEW_PAYMENT_REQUESTS = "ViewPaymentRequests",
  VIEW_PROMOCODES = "ViewPromoCodes",
  CREATE_PROMOCODES = "CreatePromoCodes",
  DELETE_PROMOCODES = "DeletePromoCodes";

export const PERMISSIONS = {
  [VIEW_PROMOCODES]: {
    displayName: "Can View Promocodes",
    category: PROMOCODE_MANAGEMENT
  },
  [CREATE_PROMOCODES]: {
    displayName: "Can Create or Edit Promocodes",
    category: PROMOCODE_MANAGEMENT
  },
  [DELETE_PROMOCODES]: {
    displayName: "Can Delete Promocodes",
    category: PROMOCODE_MANAGEMENT
  },
  [CAN_VIEW_USERS]: {
    displayName: "Can View Users",
    category: USER_MANAGEMENT
  },
  [ADD_USER]: { displayName: "Add User", category: USER_MANAGEMENT },
  [EDIT_USER_PERMISSIONS]: {
    displayName: "Edit User Permissions",
    category: USER_MANAGEMENT
  },
  [DELETE_USER]: { displayName: "Delete User", category: USER_MANAGEMENT },

  [VIEW_TRANSACTIONS]: {
    displayName: "View Transactions",
    category: TRANSACTION_MANAGEMENT
  },
  [SEARCH_TRANSACTIONS]: {
    displayName: "Search Transactions",
    category: TRANSACTION_MANAGEMENT
  },
  [EXPORT_TRANSACTIONS]: {
    displayName: "Export Transactions",
    category: TRANSACTION_MANAGEMENT
  },
  [COLLECT_FUNDS]: {
    displayName: "Collect Funds",
    category: TRANSACTION_MANAGEMENT
  },
  [PARTIAL_COLLECT_FUNDS]: {
    displayName: "Partial Collect Funds",
    category: TRANSACTION_MANAGEMENT
  },
  [REFUND_TRANSACTIONS]: {
    displayName: "Refund Transactions",
    category: TRANSACTION_MANAGEMENT
  },

  [VIEW_ACTIVITY_LOG]: {
    displayName: "View Activity Log",
    category: ACTIVITY_MANAGEMENT
  },
  [EXPORT_ACTIVITY_LOG]: {
    displayName: "Export Activity Log",
    category: ACTIVITY_MANAGEMENT
  },

  [EDIT_MERCHANT_SETTINGS]: {
    displayName: "Edit Merchant Settings",
    category: MERCHANT_SETTINGS
  },
  [VIEW_MERCHANT_SETTINGS]: {
    displayName: "View Merchant Settings",
    category: MERCHANT_SETTINGS
  },
  [SET_CUSTOM_FIELDS]: {
    displayName: "Set Custom Fields",
    category: MERCHANT_SETTINGS
  },
  [SET_LOGO]: { displayName: "Set Logo", category: MERCHANT_SETTINGS },
  [SET_BANNER]: { displayName: "Set Banner", category: MERCHANT_SETTINGS },

  [SEND_RECURRING_PAYMENT_REQUEST]: {
    displayName: "Send Recurring Payment Request",
    category: PAYMENT_REQUESTS
  },
  [CANCEL_RECURRING_PAYMENT]: {
    displayName: "Cancel Recurring Payment",
    category: PAYMENT_REQUESTS
  },
  [STANDARD_PAYMENT_REQUEST]: {
    displayName: "Standard Payment Request",
    category: PAYMENT_REQUESTS
  },
  [VIEW_PAYMENT_REQUESTS]: {
    displayName: "View Payment Requests",
    category: PAYMENT_REQUESTS
  },

  [VIEW_MERCHANTS]: { displayName: "View Merchants", category: OTHER },
  [ADD_MERCHANT]: { displayName: "Add Merchant", category: OTHER },
  [DELETE_MERCHANT]: { displayName: "Delete Merchant", category: OTHER },
  [MAKE_A_PAYMENT]: { displayName: "Make A Payment", category: OTHER }
};

export const API_KEY_SCOPES = [
  "full_access",
  "customer:read",
  "customer:write",
  "customer:get",
  "customers:get",
  "customer:create",
  "customer:update",
  "customer:delete",
  "products:read",
  "products:write",
  "product:get",
  "products:get",
  "product:create",
  "product:update",
  "product:delete",
  "product:group:create",
  "product:group:get",
  "product:groups:get",
  "product:group:update",
  "product:group:delete",
  "product:group:remove",
  "product:price:create",
  "product:price:get",
  "product:prices:get",
  "product:price:update",
  "product:price:delete",
  "subscription:read",
  "subscription:write",
  "subscription:get",
  "subscription:active:get",
  "subscription:history:get",
  "subscription:changes:get",
  "subscription:cancel",
  "payment:read",
  "payment:write",
  "intent:create",
  "transaction:read",
  "transaction:write",
  "payment-request:read",
  "event-tracer:read",
  "event-tracer:timeframe:get",
  "event-tracer:type:get",
  "event-tracer:user:get",
  "event-tracer:id:get",
  "event-tracer:trace:get"
];

export function verify(allowedGroups) {
  try {
    if (!allowedGroups || !allowedGroups.length) return true;
    const userGroups = store.getters.groups;
    return allowedGroups.some(g => userGroups.includes(g));
  } catch (e) {
    debug(e);
  }
  return false;
}

export function isMerchantAdmin() {
  return verify([MERCHANT_ADMIN]);
}

export function isAdmin() {
  return verify([ADMIN]);
}

export function isMerchantUser() {
  return !store.getters.isAuthenticated && !isAdmin && !isMerchantAdmin;
}

export default {
  verify
};
